import {
  Component, Input, TemplateRef, OnInit,
  EventEmitter,
  Output
} from "@angular/core";
import {
  GET_VEHICLE_USE, 
  SEARCH_ENDORSEMENT_MAKE_MODEL,
  SELECTED_ENDORSEMENT_MAKE_MODEL,
  UPDATE_ENDORSEMENT_STEP2, 
} from "@store/sat-motor/sat-motor.action";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { STORE_ENDORSEMENT, SEARCH_ORIXCompanyInfo } from '@store/sat-motor/sat-motor.action';
import { Store, Select } from '@ngxs/store';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { MakeModelComponent } from "@shared/components/modal/make-model/make-model.component";
import { VehicleNoValidator } from "@shared/classes/validators/vehicle-no.validator";
import { NumberRangeValidator } from "@shared/classes/validators/number-range.validator";
import { UserResponse } from "@interfaces/user";

import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { formatNumber } from "@angular/common";
import { MyDateAdapter } from "@shared/helpers/date.adapter";
import { NxDateAdapter, NX_DATE_FORMATS } from "@aposin/ng-aquila/datefield";
import { OkMessageComponent } from "@shared/components/modal/ok-message/ok-message.component";
import { MaxLengthInputDirective } from "@shared/directives/max-length-input/max-length-input.directive"
import moment, { Moment } from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-endorsement-vehicle-details',
  standalone: true,
  imports: [SharedModule],
  providers: [
    { provide: NxDateAdapter, useClass: MyDateAdapter },
    { provide: NX_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  templateUrl: './endorsement-vehicle-details.component.html',
  styleUrl: './endorsement-vehicle-details.component.scss'
})
export class EndorsementVehicleDetailsComponent implements OnInit {

  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.endtStep1Issuance) endtIssuanceData$;
  @Select(SatMotorState.endtStep2EndorsementDetails) endtEndorsementDetailsData$;

  @Select(SatMotorState.endtVehiclePolicy) endtVehicleData$;
  @Select(SatMotorState.endtPreviousVehiclePolicy) endtPreviousVehicleData$;

  @Select(SatMotorState.endtStep2VehicleDetails) endtVehicleDetailsData$;

  // coverageFmGroup!: FormGroup; //to change or remove
  // vehicleUselov!: any; //to change or remove

  // vehicleDetailsForm: FormGroup;

  dialogRef?: NxModalRef<any>;

  isEndorsement: boolean = true;
  @Input() endorsementType: any;
  // nextButtonDisabled: boolean = true;

  @Output() endtCalculatePremium = new EventEmitter<unknown>();

  vehicleDetailForm: FormGroup;

  endtVehiclePolicyData: any;
  endtPreviousVehiclePolicyData: any;

  lov: any;
  userInfo: any;
  vehicleUseLov: any;
  agentDetail: any;
  issuanceInfo: any;
  coverageType: any;
  endtPolicy: any;
  policyNo: any;

  originalRegion: any;
  originalVehicleUse: any;
  originalVehicleNo: any;
  originalVehicleMakeYear: any;
  // originalVehModelNvicDesc: any;
  originalMakeModel: any;
  originalVehicleUom: any;
  originalVehicleCapacity: any;
  originalEngineType: any;
  originalVehicleSeat: any;
  originalVehicleEngine: any;
  originalVehicleChassis: any;
  originalVehicleLoanType: any;
  originalVehicleLoanCompany: any;
  originalVariantDesc: any;

  vehicleDetails: any;
  makeModelDesc: any;

  decimalFmt: any;
  numberFmt: any;
  capacityRange: any;

  maxlength = 250;
  characterCount: number = 0;

  templateDialogRef?: NxModalRef<any>;

  openDialog(template: TemplateRef<any>, config: { height?: string; width?: string } = {}): void {
    this.templateDialogRef = this.dialogService.open(template, {
      disableClose: true,
      height: config.height || '500px',
      width: config.width || '780px',
    });
  }

  closeDialog(): void {
    this.templateDialogRef?.close();
  }

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private readonly dialogService: NxDialogService,
  ) {
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();

    this.vehicleDetailForm = this.fb.group({
      region: ["", [Validators.required]],
      vehicleUse: ["", [Validators.required]],
      //vehicleNo: ["", [Validators.required, VehicleNoValidator()]],
      vehicleNo: ["", [
        Validators.required, 
        VehicleNoValidator(),
        (control: AbstractControl) => {
          if (control.value?.toUpperCase() === "NA") {
            return { invalid: true };
          }
          return null;
        }
      ]],
      vehicleMakeYear: ["", [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(1924), Validators.max(new Date().getFullYear())]],
      // vehModelNvicDesc: ["", [Validators.required]],
      makeModel: ["", [Validators.required]],
      vehicleUom: [{ value: "", disabled: true }],
      vehicleCapacity: ["", [Validators.required]],
      engineType: [{ value: "", disabled: true }, [Validators.required]],
      vehicleSeat: ["", [Validators.required, Validators.min(1)]],
      vehicleEngine: ["", [Validators.required]],
      vehicleChassis: ["", [Validators.required]],
      vehicleLoanType: [""],
      vehicleLoanCompany: [""],
      vehiclePurchaseDate: [""],
      makeModelPrintInd: [false],
      variantDesc: [""],
      leasingCompany: [{value: "", disable: true}],
      buyerOverwriteInd: [{value: false, disabled: true }], // Dropdown defaults to null & disabled
      makeDesc: [""],
    });
  }

  ngOnInit() {

    this.capacityRange = { CC: { min: "40", max: "9,999" }, WATT: { min: "0", max: "999,999.99" } }

    this.endtVehicleData$.subscribe((state) => {
      this.endtPolicy = state || {};
      this.policyNo = state?.policyNo;
    });

    this.actionType$.subscribe((state) => {
      if (state) {
        this.isEndorsement = state.isEndorsement;
        // console.log("EndorsementVehicleDetailsComponent isEndorsement", this.isEndorsement);
      }
    });

    this.endtIssuanceData$.subscribe((state) => {
      if (state) {
        this.endorsementType = state.issuance.endorsementType;
        console.log("endorsementType", this.endorsementType);
      }
    });

    this.store.dispatch(new GET_VEHICLE_USE({ isEndorsement: true, productCode: this.endtPolicy.productCode })).subscribe((state) => {
      this.vehicleUseLov = state.SatMotorState.endorsement.step2.vehicleUseLov;
      // console.log("Vehicle Use LOV updated after dispatch:", this.vehicleUseLov);
    });

    // this.vehicleDetails = this.vehicleDetailForm;

    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);
    this.userInfo = this.store.selectSnapshot<UserResponse>((state) => state.UserState.user);
    // this.vehicleUseLov = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step2.endorsementDetails.vehicleUseLov);
    // this.agentDetail = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement.step1.agentDetail);
    this.issuanceInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement.step1.issuance.issuance);
    // this.coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement.step2?.endorsementDetails?.coverageType);

    this.vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement?.step2?.endorsementDetails?.vehicleDetails);
    console.log("vehicleDetails:", this.vehicleDetails);

    const endtVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtVehicleData);
    const endtPreviousVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtPreviousVehicleData);

    this.endtVehiclePolicyData = endtVehiclePolicyData
    this.endtPreviousVehiclePolicyData = endtPreviousVehiclePolicyData

    // console.log("endtVehiclePolicyData:", this.endtVehiclePolicyData);

    if (endtVehiclePolicyData) {
      // let customerData = endtVehiclePolicyData?.clientPartner;
      // let agentData = endtVehiclePolicyData?.mkagAgent;
      let riskList = endtVehiclePolicyData?.riskList[0];

      console.log("riskList:", riskList);

      if (riskList) {
        let data = riskList;

        if (endtVehiclePolicyData && !this.vehicleDetails) {
          this.vehicleDetailForm.patchValue({
            region: endtVehiclePolicyData.region,
            vehicleUse: data.vehicleUse,
            vehicleNo: data.vehicleNo,
            vehicleMakeYear: data.vehicleMakeYear,
            makeModel: this.getVehicleMakeModel(data), //opus is null
            vehicleUom: data.vehicleUom,
            vehicleCapacity: formatNumber(data.vehicleCapacity, 'en-US'),
            engineType: data.engineType, //opus is null
            vehicleSeat: data.vehicleSeat,
            vehicleEngine: data.vehicleEngine,
            vehicleChassis: data.vehicleChassis,
            vehicleLoanType: data.vehicleLoanType,
            vehicleLoanCompany: data.vehicleLoanCompany,
            makeModelPrintInd: data.makeModelPrintInd === 'Y',
            variantDesc: (data.variantDesc ?? ""),
            makeDesc: (data.makeModelDesc ?? "")
          });
          if (data?.makeModelPrintInd && data?.makeModelPrintInd === "Y") {
            this.makeModelDesc = data.piamMakeCodeDesc;
            this.maxlength = 250 - this.makeModelDesc.length - 1;
            this.characterCount = this.makeModelDesc.length + 1 + this.variantDesc.value.length;
          }
          console.log("endtVehiclePolicyData vehicleDetailForm:", this.vehicleDetailForm);

          this.populateSelectedMakeModel(data.vehicleClass, data.vehicleMakeYear, data.vehModelNvic?.trim() ? data.vehModelNvic : data.vehicleModel);
        }
        else if (endtVehiclePolicyData && this.vehicleDetails) {
          this.vehicleDetailForm.patchValue(this.vehicleDetails);
          console.log("vehicleDetails vehicleDetailForm:", this.vehicleDetailForm);
          // // this.vehicleDetailForm.patchValue({ ...this.vehicleDetails, vehicleCapacity: formatNumber(this.vehicleDetails.vehicleCapacity, 'en-US') });
          if (this.makeModelPrintInd.value) {
            this.makeModelDesc = (this.vehicleDetails.makeDesc ?? data.makeModelDesc) || data.piamMakeModelDesc; //AGIC-49986 //AGIC-49986
            this.maxlength = 250 - this.makeModelDesc.length - 1;
            this.characterCount = this.makeModelDesc.length + 1 + this.variantDesc.value.length;
          }
        }

        this.applyFormControlRules();

        //store original db values
        this.originalRegion = endtVehiclePolicyData.region;
        this.originalVehicleUse = data.vehicleUse;
        this.originalVehicleNo = data.vehicleNo;
        this.originalVehicleMakeYear = data.vehicleMakeYear;
        // this.originalVehModelNvicDesc = data.vehModelNvicDesc;
        this.originalMakeModel = data.piamMakeModelDesc + ' ' + data.variantFullDesc;
        this.originalVehicleUom = data.vehicleUom;
        this.originalVehicleCapacity = data.vehicleCapacity;
        this.originalEngineType = data.engineType;
        this.originalVehicleSeat = data.vehicleSeat;
        this.originalVehicleEngine = data.vehicleEngine;
        this.originalVehicleChassis = data.vehicleChassis;
        this.originalVehicleLoanType = data.vehicleLoanType;
        this.originalVehicleLoanCompany = data.vehicleLoanCompany;
        this.originalVariantDesc = data.variantDesc;
      } else {
        console.error("riskList cannot populate vehicleDetailForm");
      }
    } else {
      console.error("endtVehiclePolicyData is undefined");
    }
    ////////////////////////////////////////////////////////
    this.vehicleLoanType.valueChanges.subscribe((change) => {
      this.vehicleDetailForm.patchValue({ vehicleLoanCompany: "" });
      this.appendValidators(change, this.vehicleLoanCompany);
      this.vehicleLoanCompany.markAsUntouched();
    });

    // let vehicleData = this.vehicleDetails;
    // if (endtVehiclePolicyData && !this.vehicleDetails) {
    //   vehicleData = endtVehiclePolicyData?.riskList[0];
    // }

    this.makeModelPrintInd.valueChanges.subscribe((change) => {
      if (change) {
        const selectedEndtModel = this.store.selectSnapshot<any>((state) => state.SatMotorState?.data?.step2?.endorsementDetails?.selectedMakeModel);
        let vehicleData;
        let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
        let endtVariantCodeDescFullDesc = [selectedEndtModel?.piamModelCodeDesc, selectedEndtModel?.variantFullDesc].join(" ").trim();
        if (endtUpdatedData.riskList.length) vehicleData = endtUpdatedData.riskList[0];
        this.makeModelDesc = selectedEndtModel?.piamMakeCodeDesc || vehicleData?.piamMakeModelDesc;
        this.maxlength = 250 - this.makeModelDesc.length - 1;
        this.characterCount = this.makeModelDesc.length + 1 + endtVariantCodeDescFullDesc.length;
        this.vehicleDetailForm.patchValue({  variantDesc: endtVariantCodeDescFullDesc || selectedEndtModel?.variantFullDesc,
          makeDesc: this.makeModelDesc
         });
      } else {
        this.makeModelDesc = "";
        this.maxlength = 250;
        this.characterCount = 0;
        this.vehicleDetailForm.patchValue({ variantDesc: "" });
      }
      this.appendValidators(change, this.variantDesc);
    });
    
    this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.endtVehiclePolicyData.mkagAgent.agentCode, 
      loanCompany: this.endtVehiclePolicyData.riskList[0].vehicleLoanCompany, loanType: this.endtVehiclePolicyData.riskList[0].vehicleLoanType, 
      vehType: this.endtVehiclePolicyData.productCode, eInvoiceInd: this.endtVehiclePolicyData.einvoiceConsentInd})).subscribe((state) =>{
        if(state.SatMotorState.lov.searchORIXCompany){
          this.lov = {
            ...this.lov,
            searchORIXCompany: state.SatMotorState?.lov?.searchORIXCompany,
          };
        }
        this.vehicleDetailForm.patchValue({
          leasingCompany: this.endtVehiclePolicyData.leasCompCode,
          buyerOverwriteInd: this.endtVehiclePolicyData.buyerOverwriteInd
        });
      });
  }

  getVehicleMakeModel(data: any): any {
    let desc;

    if (data && data.vehModelNvic && data.vehModelNvic.trim() !== '') { //new model
      desc = [data.piamMakeCodeDesc, data.piamModelCodeDesc, data.variantFullDesc].join(" ").trim();

    } else if (data && data.vehicleModel && data.vehicleModel.trim() !== '') { //old model
      desc = data.vehicleModelDescp;
    }

    return desc;
  }

  populateSelectedMakeModel(classCode, yearMnftr, vehModelNvic) {
    this.store.dispatch(
      new SEARCH_ENDORSEMENT_MAKE_MODEL({
        type: "", classCode: classCode, yearMnftr: yearMnftr,
      }),
    ).subscribe((state) => {
      this.store.dispatch(
        new SELECTED_ENDORSEMENT_MAKE_MODEL(state.SatMotorState.data.step2.endorsementDetails.searchMakeModelList.find((mm) => mm.vehModelCodeNvic === vehModelNvic)));
    });
  }

  normalizeValue(value: any) {
    if (typeof value === 'string') {
      return value.trim().toLowerCase();
    }
    return value;
  }

  convertToComparableType(value: any, referenceValue: any) {
    if (typeof referenceValue === 'number' && !isNaN(Number(value))) {
      return Number(value);
    }
    if (typeof referenceValue === 'string') {
      return String(value);
    }
    return value;
  }
  
  validateFields() {
    return this.vehicleDetailForm.valid;
  }

  displayError() { //AGIC-49480
    if (this.vehicleDetailForm.invalid) {
      Object.values(this.vehicleDetailForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }
  }

  validateChangedFields() {
    const fieldsToValidate = this.getFieldsToValidate();
    console.log("fieldsToValidate:", fieldsToValidate);

    let changedFieldsCount = 0;
    let sameFieldsCount = 0;
    let totalFields = fieldsToValidate.length;
    let hasChanged = false;

    fieldsToValidate.forEach((field) => {
      let formValue = this.normalizeValue(this.vehicleDetailForm.get(field)?.value);
      if (field === 'vehicleCapacity' && formValue) {
        formValue = formValue.toString().replace(/,/g, '');
      }
      console.log("validateChangedFields formValue:", formValue);

      let originalValue = this.normalizeValue(this[`original${this.capitalizeFirstLetter(field)}`]);
      if (field === 'vehicleCapacity' && originalValue) {
        originalValue = originalValue.toString().replace(/,/g, '');
      }
      console.log("validateChangedFields originalValue:", originalValue);

      if (originalValue === undefined) {
        console.error(`Original value for ${field} is undefined`);
      }

      formValue = this.convertToComparableType(formValue, originalValue);
      originalValue = this.convertToComparableType(originalValue, formValue);

      if (this.endorsementType === 'ENDT18') {
        if (originalValue === "" && formValue === "null"){
          formValue = originalValue;
        }
      }

      if (formValue !== originalValue) {
        changedFieldsCount++;
        console.log(`Field ${field} has changed.`);
      } else if (formValue === originalValue) {
        sameFieldsCount++;
        console.log(`Field ${field} has not changed.`);
      }
    });

    //AGIC-49418 - Commented
    // if (this.endorsementType === 'ENDT18') {
    //   const vehicleLoanTypeValue = this.vehicleDetailForm.get('vehicleLoanType')?.value;
    //   if (vehicleLoanTypeValue === "") {
    //     changedFieldsCount = totalFields;
    //   } else {
    //     const vehicleLoanCompanyValue = this.vehicleDetailForm.get('vehicleLoanCompany')?.value;
    //     if (vehicleLoanCompanyValue === "") {
    //       changedFieldsCount = 1;
    //     }
    //   }
    // }

    if (this.endorsementType === 'ENDT34') {
      // console.log("validateChangedFields endorsementType:", this.endorsementType);
      const makeModelPrintIndValue = this.vehicleDetailForm.get('makeModelPrintInd')?.value;
      if (makeModelPrintIndValue === true) {
        // totalFields = 5;
        totalFields = 3;
        changedFieldsCount++;

        const variantDescValue = this.vehicleDetailForm.get('variantDesc')?.value;
        if (variantDescValue !== "") {
          changedFieldsCount++;
        }
      }
    }

    if (this.endorsementType === 'COE') {
      if (changedFieldsCount > 0 && changedFieldsCount < totalFields) {
        changedFieldsCount = totalFields;
        sameFieldsCount = 0;
      }
    }

    console.log("changedFieldsCount:", changedFieldsCount);
    console.log("sameFieldsCount:", sameFieldsCount);
    if (this.endorsementType === 'ENDT18') {
      if (changedFieldsCount > 0) {
        hasChanged = true;
      }
    } else if (changedFieldsCount === totalFields && sameFieldsCount === 0) {
      hasChanged = true;
    } else {
      hasChanged = false;
    }
    console.log("Final hasChanged result:", hasChanged);
    return hasChanged;
  }

  getFieldsToValidate() {
    switch (this.endorsementType) {
      case 'COE': //Change of Engine
        return ['vehicleEngine', 'vehicleCapacity'];
      // return ['vehicleEngine', 'vehicleCapacity'];
      case 'ENDT10': //Change of Vehicle Chassis No
        return ['vehicleChassis'];
      case 'ENDT12': //Change of Vehicle Registration No
        return ['vehicleNo'];
      case 'ENDT18': //Hire Purchase/Employers' Loan/Leasing
        return ['vehicleLoanType', 'vehicleLoanCompany'];
      case 'ENDT34': // Change of Make & Model
        return ['makeModel'];
      // return ['vehModelNvicDesc'];
      // return ['vehModelNvicDesc', 'vehicleCapacity', 'vehicleSeat'];
      default:
        return [];
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  applyFormControlRules() {
    if (this.endorsementType === 'COE') { //Change of Engine
      this.vehicleDetailForm.get('vehicleEngine')?.enable();
      this.vehicleDetailForm.get('vehicleCapacity')?.enable();
      this.disableOtherControls(['vehicleEngine', 'vehicleCapacity']);
      this.applyCapacityRules();

    } else if (this.endorsementType === 'ENDT10') { //Change of Vehicle Chassis No
      this.vehicleDetailForm.get('vehicleChassis')?.enable();
      this.disableOtherControls(['vehicleChassis']);

    } else if (this.endorsementType === 'ENDT12') { //Change of Vehicle Registration No
      this.vehicleDetailForm.get('vehicleNo')?.enable();
      this.disableOtherControls(['vehicleNo']);

    } else if (this.endorsementType === 'ENDT18') { //Hire Purchase/Employers' Loan/Leasing
      this.vehicleDetailForm.get('vehicleLoanType')?.enable();
      this.vehicleDetailForm.get('vehicleLoanCompany')?.enable();
      this.disableOtherControls(['vehicleLoanType', 'vehicleLoanCompany']);

      // const vehicleLoanType = this.vehicleDetailForm.get('vehicleLoanType')?.value;
      this.appendValidators(this.vehicleLoanType.value, this.vehicleLoanCompany);

    } else if (this.endorsementType === 'ENDT34') { // Change of Make & Model
      this.vehicleDetailForm.get('makeModel')?.enable();
      // this.vehicleDetailForm.get('vehModelNvicDesc')?.enable();
      this.vehicleDetailForm.get('vehicleCapacity')?.enable();
      this.vehicleDetailForm.get('vehicleSeat')?.enable();
      this.vehicleDetailForm.get('makeModelPrintInd')?.enable();
      this.vehicleDetailForm.get('variantDesc')?.enable();
      this.disableOtherControls(['makeModel', 'vehicleCapacity', 'vehicleSeat', 'makeModelPrintInd', 'variantDesc']);
      this.applyCapacityRules();
    }
  }

  applyCapacityRules() {
    const vehicleUom = this.vehicleDetailForm.get('vehicleUom')?.value;

    if (vehicleUom === "CC") {
      this.vehicleDetailForm.get('vehicleCapacity')?.setValidators([
        Validators.required, Validators.min(1), NumberRangeValidator(this.numberFmt.transform(this.capacityRange.CC.min), this.numberFmt.transform(this.capacityRange.CC.max))
      ]);
      this.vehicleDetailForm.get('vehicleCapacity')?.updateValueAndValidity();
    } else if (vehicleUom === "WATT") {
      this.vehicleDetailForm.get('vehicleCapacity')?.setValidators([
        Validators.required, Validators.min(0), NumberRangeValidator(this.numberFmt.transform(this.capacityRange.WATT.min), this.numberFmt.transform(this.capacityRange.WATT.max))
      ]);
      this.vehicleDetailForm.get('vehicleCapacity')?.updateValueAndValidity();
    }
  }

  disableOtherControls(allowedControls: string[]) {
    Object.keys(this.vehicleDetailForm.controls).forEach((control) => {
      if (!allowedControls.includes(control)) {
        this.vehicleDetailForm.get(control)?.disable();
      }
    });
  }
  ///////////////////////////////////////////////////////////////
  onChangeCapacity($event, comma: boolean, calculate: boolean) {
    if (!comma) {
      if ($event.target.value)
        this.vehicleCapacity.patchValue(this.numberFmt.transform($event.target.value));
    } else {
      if ($event.target.value)
        this.vehicleCapacity.patchValue(formatNumber(this.numberFmt.transform($event.target.value), 'en-US'));
    }
  }

  onUseOfVehicleChange($event) { //to reconfirm the flow with state here
    if (this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement.step2.endorsementDetails?.coverageType)) {
      // this.calculatePremium();
    }
  }

  // to confirm if vehicle no. retrieval is necessary
  onChangeVehicleNo($event) {
    // this.store.dispatch(new GET_PREVIOUS_POLICY_NO({ vehicleNo: $event.target.value, agentCode: this.agentDetail.agentCode })).subscribe((res) => {
    //   let previousPolicy = res.SatMotorState.endorsement?.step1?.previousPolicy;
    //   console.log(previousPolicy);
    // });
  }

  onLoanTypeChange(event: any) {
    if (event.value === null) {
      this.vehicleLoanType?.setValue('');
    }
  }

  onLoanCompanyChange($event: any) {
    let loanCompany = $event.target.value;
    if (loanCompany) {
      this.vehicleLoanType.setValidators([Validators.required]);
    } else {
      this.vehicleLoanType.clearValidators();
    }
    this.vehicleLoanType.updateValueAndValidity();
    this.vehicleLoanCompany.setValue(loanCompany);
  }

  // Make Model search pop up
  openPopupMakeModel() {

    if (this.endorsementType !== "ENDT34") {
      return;
    }

    // Make Model search component
    this.dialogRef = this.dialogService.open(MakeModelComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: "95%",
      maxWidth: "930px",
      // Make Model data to send for the api request
      data: {
        region: this.endtVehiclePolicyData.region,
        vehicleClass: this.vehicleUseLov.filter((v) => v.code === this.vehicleUse.value)[0].vehicleClass,
        yearMnftr: this.vehicleMakeYear.value
      }
    });
    // console.log("dialogRef:", this.dialogRef);

    // Make Model selected data stored after closing search bar
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(new SELECTED_ENDORSEMENT_MAKE_MODEL(result.item)).subscribe((state) => {
          this.resetMakeModelForm();
          this.patchMakeModelForm(result);

          console.log("EndorsementVehicleDetailsComponent result:", result);

          let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);

          if (endtUpdatedData?.riskList[0]?.avInd) {
            this.dialogService.open(OkMessageComponent, {
              disableClose: true,
              width: "400px",
              data: {
                message: "The vehicle is on Indemnity Value.",
              },
            }).afterClosed().subscribe(() => {
              this.updateData(result);
            });
          } else {
            this.updateData(result);
          }
        });
      }
    });
  }

  updateData(result) {

    let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);

    endtUpdatedData = {
      ...endtUpdatedData,
      riskList: [{
        ...endtUpdatedData.riskList[0],
        avInd: false,
        vehModelNvic: result.item.vehModelCodeNvic,
        vehicleMakeYear: result.item.yearMnftr,
        vehicleSeat: result.item.seat,
        vehicleCapacity: result.item.capacity,
        vehicleUom: result.item.uom,
        avCode: result.item.avCode,
        vehicleEngine: result.item.engineType,
        variantDesc: result.item.variantFullDesc,
        makeModel: result.item.piamMakeModelDesc,
        vehicleModel: result.item.vehModelCodeNvic,
        vehicleModelDescp: result.item.piamMakeModelDesc + ' ' + result.item.variantFullDesc,
        piamMakeModelDesc: result.item.piamMakeModelDesc,
        importStatus: result.item.importStatus,
        makeModelDesc: result.item.piamMakeCodeDesc,
        coverList: [{
          ...endtUpdatedData.riskList[0].coverList[0],
          makeModelSiMin: endtUpdatedData?.region === 'W' ? result.item?.avWmSiMin :
                          endtUpdatedData?.region === 'E' ? result.item?.avEmSiMin : undefined,
          makeModelSiMax: endtUpdatedData?.region === 'W' ? result.item?.avWmSiMax :
                          endtUpdatedData?.region === 'E' ? result.item?.avEmSiMax : undefined,
          avInd: false
        }]
      }]
    };

    this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
      isReset: false,
      cngeNote: endtUpdatedData
    }));

    this.endtCalculatePremium.emit();
  }

  resetMakeModelForm() {
    this.vehicleDetailForm.patchValue({
      makeModel: "",
      vehicleUom: "",
      vehicleCapacity: "",
      engineType: "",
      vehicleSeat: "",
      makeModelPrintInd: false,
      variantDesc: "", 
    });
    this.makeModelDesc = "";
    this.characterCount = 0;
  }

  patchMakeModelForm(dt) {
    let data = dt.item ?? dt;
    console.log("EndorsementVehicleDetailsComponent data:", data);

    this.vehicleDetailForm.patchValue({
      makeModel: [data.piamMakeCodeDesc, data.piamModelCodeDesc, data.variantFullDesc].join(" ").trim(),
      vehicleUom: data.uom,
      vehicleCapacity: formatNumber(data.capacity, 'en-US'),
      engineType: data.engineType,
      vehicleSeat: data.seat,
      makeDesc: data.piamMakeCodeDesc,
    });
    console.log("EndorsementVehicleDetailsComponent vehicleDetailForm:", this.vehicleDetailForm);
  }
  //////////////////////////////////////////////////////////////////////
  private appendValidators(change: any, element: AbstractControl<any>) {
    if (change) {
      element.setValidators([Validators.required]);
    } else {
      element.clearValidators();
    }

    if (element)
      element.updateValueAndValidity();
  }

  onKeyUp(event: any) {
    this.characterCount = this.makeModelDesc?.length + 1 + event.target.value.length;
  }

  get vehicleUse() {
    return this.vehicleDetailForm.controls["vehicleUse"];
  }

  get vehicleNo() {
    return this.vehicleDetailForm.controls["vehicleNo"];
  }

  get vehicleMakeYear() {
    return this.vehicleDetailForm.controls["vehicleMakeYear"];
  }

  // get vehModelNvicDesc() {
  //   return this.vehicleDetailForm.controls["vehModelNvicDesc"];
  // }

  get vehicleCapacity() {
    return this.vehicleDetailForm.controls["vehicleCapacity"];
  }

  get engineType() {
    return this.vehicleDetailForm.controls["engineType"];
  }

  get vehicleSeat() {
    return this.vehicleDetailForm.controls["vehicleSeat"];
  }

  get vehicleEngine() {
    return this.vehicleDetailForm.controls["vehicleEngine"];
  }

  get vehicleChassis() {
    return this.vehicleDetailForm.controls["vehicleChassis"];
  }

  get vehicleLoanType() {
    return this.vehicleDetailForm.controls["vehicleLoanType"];
  }

  get vehicleLoanCompany() {
    return this.vehicleDetailForm.controls["vehicleLoanCompany"];
  }

  get makeModelPrintInd() {
    return this.vehicleDetailForm.controls["makeModelPrintInd"];
  }

  get makeModel() {
    return this.vehicleDetailForm.controls["makeModel"];
  }

  get vehicleUom() {
    return this.vehicleDetailForm.controls["vehicleUom"];
  }

  get variantDesc() {
    return this.vehicleDetailForm.controls["variantDesc"];
  }
  //////////////////////////////////////////////////////

  storeEndorsementDetailsData() {
    if (this.vehicleDetailForm.valid) {
      let vehicleDetails = this.vehicleDetailForm.getRawValue();
      console.log('Saving Vehicle Details Data:', vehicleDetails);
      let payload = {
        vehicleDetails: vehicleDetails,
        isVehicleDetails: true
      }
      this.store.dispatch(new STORE_ENDORSEMENT(payload));

      let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
      if (!endtUpdatedData) {
        endtUpdatedData = this.endtVehiclePolicyData
      }
      endtUpdatedData = {
        ...endtUpdatedData,
        riskList: [{
          ...endtUpdatedData.riskList[0],
          vehicleUse: vehicleDetails.vehicleUse,
          vehicleNo: vehicleDetails.vehicleNo,
          vehicleMakeYear: vehicleDetails.vehicleMakeYear,
          makeModel: vehicleDetails.piamMakeModelDesc + ' ' + vehicleDetails.variantFullDesc, //opus is null
          vehicleUom: vehicleDetails.vehicleUom,
          vehicleCapacity: vehicleDetails.vehicleCapacity,
          engineType: vehicleDetails.engineType, //opus is null
          vehicleSeat: vehicleDetails.vehicleSeat,
          vehicleEngine: vehicleDetails.vehicleEngine,
          vehicleChassis: vehicleDetails.vehicleChassis,
          vehicleLoanCompany: vehicleDetails.vehicleLoanCompany,
          vehicleLoanType: vehicleDetails.vehicleLoanType,
          vehiclePurchaseDate: vehicleDetails.vehiclePurchaseDate,
          variantDesc: vehicleDetails.variantDesc,
          makeModelDesc: vehicleDetails.makeDesc
        }]
      };

      if (!vehicleDetails.makeModelPrintInd) {
        endtUpdatedData = {
          ...endtUpdatedData,
          riskList: [{
            ...endtUpdatedData.riskList[0],
            makeModelPrintInd: "N"
          }]
        };
      } else {
        endtUpdatedData = {
          ...endtUpdatedData,
          riskList: [{
            ...endtUpdatedData.riskList[0],
            makeModelPrintInd: "Y"
          }]
        };
      }

      this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
        isReset: false,
        cngeNote: endtUpdatedData
      }));

      // let nonPremiumEndtTypes = ['ENDT10', 'ENDT12', 'ENDT18', 'EC175', 'EC176'];
      // if (!nonPremiumEndtTypes.includes(this.endorsementType)) {
        this.endtCalculatePremium.emit();
      // }

    } else {
      console.error('Vehicle Details form is invalid!');
      // this.logFormErrors(this.vehicleDetailForm);
      this.vehicleDetailForm.markAllAsTouched();
    }
  }
////////////////////////////////////////////////
}
